<template>
    <DsCard
        class="card"
        elevation="z0"
    >
        <DsCardHeader>
            <h2>
                {{ title }}
            </h2>
        </DsCardHeader>

        <DsCardBody class="card-body">
            <p class="subtitle">
                {{ subtitle }}
            </p>
            <p class="total">
                {{ total }}
            </p>
            <div class="button-section">
                <DsIconButton
                    class="card-button"
                    name="info-circle"
                    @click="openInfo"
                />
                <DsIconButton
                    class="card-button"
                    name="arrow-long-right"
                    @click="$emit('open-report')"
                />
            </div>
        </DsCardBody>
    </DsCard>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        total: {
            type: String,
            required: true,
        },
        articleUrl: {
            type: String,
            default: '',
        },
    },

    emits: ['open-popup', 'open-report'],

    methods: {
        openInfo() {
            if (this.articleUrl) {
                window.open(this.articleUrl, '_blank', 'noopener,noreferrer');
            } else {
                this.$emit('open-popup');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
    .card {
        width: px-to-rem(178);
        height: px-to-rem(200);
        align-self: flex-start;
        z-index: 50;

        &:active {
            box-shadow: $elevation-z0;
        }
    }

    .card-body {
        padding-top: $spacing-125;
        line-height: $line-height-sm;
    }

    .subtitle {
        font-size: $font-size-xs;
        font-weight: $font-weight-regular;
        color: $color-ink-800;
        margin-bottom: 0;
    }

    .total {
        font-size: $font-size-mega;
        font-weight: $font-weight-semibold;
        line-height: $line-height-mega;
    }

    .button-section {
        bottom: 0;
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .card-button {
        color: $color-blue;
        padding-left: 0;
        padding-right: 0;
        &:hover {
            background-color: transparent;
        }
    }

    h2 {
        padding-top: $spacing-125;
        padding-left: $spacing-200;
        font-size: $font-size-md;
        font-weight: $font-weight-semibold;
    }
</style>
